$(window).load(function () {


});

$(window).on('beforeunload', function () {
});

$(window).ready(function () {

    function init() {
        loadMore();
        home();
        loadMoreRealisaties();
        backToTopButton();
        //contact();
    }

    function loadMore() {
        $(".history-box").slice(0, 3).show();
        $("body").on('click touchstart', '.load-more', function (e) {
            e.preventDefault();
            $(".history-box:hidden").slice(0, 3).slideDown();
            if ($(".history-box:hidden").length == 0) {
                $(".load-more").css('visibility', 'hidden');
            }
        });
    }

    function loadMoreRealisaties() {
        $(".realisatie-box").slice(0, 3).show();
        $("body").on('click touchstart', '.load-more', function (e) {
            e.preventDefault();
            $(".realisatie-box:hidden").slice(0, 3).slideDown();
            if ($(".realisatie-box:hidden").length == 0) {
                $(".load-more").css('visibility', 'hidden');
            }
        });
    }

    function backToTopButton() {

        $(window).scroll(function(){
            if($(this).scrollTop() > 50){
                $('#topBtn').fadeIn();
                $('#topBtn1').fadeIn();
                $('#topBtn2').fadeIn();
            }else{
                $('#topBtn').fadeOut();
                $('#topBtn1').fadeOut();
                $('#topBtn2').fadeOut();
            }
        });

        $('#topBtn, #topBtn1, #topBtn2').click(function(){
            $('html ,body').animate({scrollTop : 0},80);
        });

    }

    function home() {

        $('#homeBannerCarousel').carousel({
            interval: 7000,
        });

        $('#homeRecenteCarousel').carousel({
            pause: true,
            interval: false
        });
    }

    $(document).ready(function () {


        // show the alert
        setTimeout(function () {
            $(".success-message").alert('close');
        }, 4000);

        setTimeout(function () {
            $(".alert").alert('close');
        }, 10000);

        setTimeout(function() {
            $('#homeBannerCarousel #scroll-image').removeClass("d-lg-block");
            $('#homeBannerCarousel #scroll-image').fadeOut(7000);
            $('#homeBannerCarousel #scroll-image').addClass("d-lg-none");
        }, 10000);
    });

    $(document).on('click', '[data-toggle="lightbox"]', function (event) {
        event.preventDefault();
        $(this).ekkoLightbox({
            loadingMessage: true,
        });
    });

    // function contact() {

    //     $('#contactform form').on('submit', function (e) {
    //         e.preventDefault();
    //         if (document.getElementById('interesse1').checked && document.getElementById('Particulier').checked && document.getElementById('Vlaanderen').checked && document.getElementById('2020').checked) {
    //             e.preventDefault();

    //             $("html, body").animate({
    //                 scrollTop: 0
    //             }, "slow");

    //             $('#contactform form .message').addClass('hidden');
    //             $('#contactform form').addClass('loading');
    //             $('.custom-message').removeClass('hidden');
    //             $('.custom-message').attr('id', 'plaatsingboodschap');
    //             $(' .error-message').addClass('hidden');
    //         } else {
    //             e.preventDefault();

    //             $("html, body").animate({
    //                 scrollTop: 0
    //             }, "slow");

    //             $('#contactform form .message').addClass('hidden');
    //             $('#contactform form').addClass('loading');
    //             $('.custom-message').addClass('hidden');
    //             $.post($('#contactform form').attr('action'), $('#contactform form').serialize(), function (response) {
    //                 $('#contactform form .data').removeClass('loading');
    //                 $('.custom-message').addClass('hidden');

    //                 if (response == 'true') {
    //                     $('.custom-message').addClass('hidden');
    //                     $('.success-message').removeClass('hidden');
    //                     $('.success-message').attr('id', 'bedanktboodschap');
    //                     $(' .error-message').addClass('hidden');
    //                     $('#contactform form').addClass('hidden');

    //                     if ($('html').attr('lang') == 'nl') {
    //                         window.history.pushState('', '', '/nl/contact/bedankt');
    //                         ga('send', 'pageview', '/nl/contact/bedankt');
    //                         gtag('config', 'UA-90005624-1', {
    //                             'page_path': '/nl/contact/bedankt'
    //                         });
    //                     } else {
    //                         window.history.pushState('', '', '/fr/contactez-nous/merci');
    //                         ga('send', 'pageview', '/fr/contactez-nous/merci');
    //                         gtag('config', 'UA-90005624-1', {
    //                             'page_path': '/fr/contactez-nous/merci'
    //                         });
    //                     }
    //                 } else {
    //                     grecaptcha.reset();
    //                     $(' .error-message').removeClass('hidden');
    //                 }
    //             });
    //         }
    //     });

    // }


    init();
});
